import type { useTranslations } from 'next-intl';

export type SurveyStep = {
  heading: string[];
  options: string[];
  customResponse?: string;
  followUpQuestions?: { forOption: string; question: string; placeholder?: string }[];
  fields: string[];
};

export function createGeneralSurveySteps(t: ReturnType<typeof useTranslations>): SurveyStep[] {
  return [
    {
      heading: [t('content.survey.experience_heading')],
      options: [
        t('content.survey.experience_bad'),
        t('content.survey.experience_ok'),
        t('content.survey.experience_good')
      ],
      fields: ['happiness']
    },
    {
      heading: [t('content.survey.liked_heading')],
      options: [] as string[],
      customResponse: t('content.survey.liked_prompt'),
      fields: ['customResponse']
    },
    {
      heading: [t('content.survey.disliked_heading')],
      options: [] as string[],
      customResponse: t('content.survey.disliked_prompt'),
      fields: ['customResponse']
    },
    {
      heading: [t('content.survey.first_visit_heading')],
      options: [t('common.yes'), t('common.no')],
      fields: ['singleOption']
    },
    {
      heading: [t('content.survey.contact_heading'), t('content.survey.contact_subheading')],
      options: [] as string[],
      fields: ['email', 'consent']
    },
    {
      heading: [t('content.survey.thanks_heading')],
      options: [] as string[],
      fields: [] as string[]
    }
  ];
}
